import { Investment } from "../generated/investment-model";
import { InvestmentStatusChangeLogEntry } from "../generated/investment-status-change-log-entry-model";
import { InvestmentStatusValues, RoleNames } from "./utils";

export interface InvestmentStatusTransition {
  from: InvestmentStatusValues;
  to: InvestmentStatusValues;
  permissions: Array<RoleNames>;
  condition: (investment: Investment) => boolean;
}

export const investmentStatusTransitions : Array<InvestmentStatusTransition> = [{
  from: InvestmentStatusValues.AWAITING_PAYMENT,
  to: InvestmentStatusValues.CANCELED,
  permissions: [RoleNames.ADMIN],
  condition: () => true,
}, {
  from: InvestmentStatusValues.AWAITING_PAYMENT,
  to: InvestmentStatusValues.CONFIRMED,
  permissions: [RoleNames.ADMIN],
  condition: () => true,
}, {
  from: InvestmentStatusValues.AWAITING_PAYMENT,
  to: InvestmentStatusValues.REVOKE_REQUESTED,
  permissions: [RoleNames.USER],
  condition: () => true,
}, {
  from: InvestmentStatusValues.AWAITING_PAYMENT,
  to: InvestmentStatusValues.UNPAID,
  permissions: [RoleNames.SYSTEM],
  condition: (investment: Investment) => !isPaid(investment),
}, {
  from: InvestmentStatusValues.CONFIRMED,
  to: InvestmentStatusValues.REVOKED,
  permissions: [RoleNames.ADMIN],
  condition: () => true,
}, {
  from: InvestmentStatusValues.REVOKE_REQUESTED,
  to: InvestmentStatusValues.REVOKED,
  permissions: [RoleNames.ADMIN],
  condition: () => true,
}, {
  from: InvestmentStatusValues.REVOKED,
  to: InvestmentStatusValues.REFUNDED,
  permissions: [RoleNames.ADMIN],
  condition: (investment: Investment) => isPaid(investment),
}];

export const isPaid = (investment: Investment) => {
  return !!investment.statusChangeLog && !!investment.statusChangeLog.find((change: InvestmentStatusChangeLogEntry) => change.status === InvestmentStatusValues.CONFIRMED);
}